// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import applyStoredConsentSource, { resolvePrivacyCookieName } from './applyStoredConsentSource';

const DEFAULT_EGSM = {
  enabled: false,
  ad_storage: 'NOT_SET',
  ad_user_data: 'NOT_SET',
  ad_personalization: 'NOT_SET',
  analytics_storage: 'NOT_SET',
};

export default function buildSettingsTemplateFromFile({ file, consentCategories = [], hasConsentModule = false }) {
  const { pipeline, settings, identitySyncs, integrations, googleTagSettings } = file;

  const syncs =
    identitySyncs?.map(sync => {
      const { friendlyName, ...settingsWithoutFriendlyName } = sync.settings ?? {};
      const result = {
        name: sync.identity_sync.name,
        friendlyName: friendlyName ?? sync.identity_sync.friendlyName,
        settings: settingsWithoutFriendlyName,
      };

      if (sync.consent_category?.code) {
        result.consentSettings = {
          code: sync.consent_category.code,
          tcfEnabled: sync.tcfEnabled ?? false,
        };
        result.consentCategoryId = sync.consentCategoryId;
      }
      if (sync.tcfEnabled !== null && sync.tcfEnabled !== undefined) {
        result.tcfEnabled = sync.tcfEnabled;
      }

      return result;
    }) ?? [];

  const storageType = settings?.storageType ?? 'INDEXED_DB';
  const impliedConsent = settings?.impliedConsent ?? false;

  const syncInjectorSettings = {
    queueTasks: true,
    timeout: 10000,
    syncs,
    privacy: {
      impliedConsent,
      cookieName: resolvePrivacyCookieName(settings),
      consentProvider: 'OneTrust',
    },
    storage: {
      type: storageType,
      marker: settings?.storagePrefix ?? 'ajs_',
    },
    itpSettings: {
      enabled: settings?.itpSettings ?? false,
      timeout: 1000,
    },
  };

  if (storageType === 'INDEXED_DB' && settings?.storageDatabase) {
    syncInjectorSettings.storage.database = settings.storageDatabase;
  }

  if (googleTagSettings) {
    syncInjectorSettings.googleGtagSettings = {
      tagID: googleTagSettings.tagId,
      loadGtag: googleTagSettings.loadGtag ?? false,
      consent: {
        loadWhenConsentDenied: googleTagSettings.loadWhenConsentDenied ?? false,
      },
      egsm: googleTagSettings.egsm ?? DEFAULT_EGSM,
    };
  }

  if (hasConsentModule && consentCategories.length > 0) {
    const consentCodes = consentCategories.map(category => category.code);
    const matchIDConsentCodeID = settings?.matchIDConsentCode ?? '';
    const matchIDConsentCode = consentCategories.find(category => category.id === matchIDConsentCodeID)?.code;

    syncInjectorSettings.consent = {
      codes: consentCodes,
      explicitConsent: !impliedConsent,
      matchIDConsentCode,
      matchIDConsentCodeID,
    };

    applyStoredConsentSource(syncInjectorSettings.consent, settings);
  }

  const host = settings?.host ?? '';
  const normalizedHost = host && !host.startsWith('https://') && !host.startsWith('http://') ? `https://${host}` : host;

  return {
    writeKey: pipeline?.writekey,
    host: normalizedHost,
    cdnURL: settings?.cdnURL ?? 'cdn.metarouter.io',
    fileHostingType: settings?.fileHostingType ?? 'SELF',
    minifyFile: settings?.minifyFile ?? true,
    windowVariableName: settings?.windowVariableName ?? 'analytics',
    syncInjectorSettings,
    integrations: integrations ?? [],
    optimizeBuild: true,
  };
}
